import { render } from "./SearchSuggestions.vue?vue&type=template&id=fa9f1748"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__